import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import React from 'react';
import { useQueryClient } from 'react-query';
import { useSetLineItemCalculationState } from '../../../../../hooks/requests/use-set-line-item-calculation-state';
import { runMutation } from '../../../../../utils/vy-mutation';
import { useDynamicInvoice } from '../../dynamic-invoice-context';

type DynamicInvoiceDisableUsageLineItemProps = {
  lineItemId: string;
  disabled: boolean;
  customerId: string;
  closeMenu?: () => void;
};

export const DynamicInvoiceDisableUsageLineItem: React.FC<DynamicInvoiceDisableUsageLineItemProps> = ({
  lineItemId,
  disabled,
  customerId,
  closeMenu,
}) => {
  const queryClient = useQueryClient();
  const { dynamicInvoiceData } = useDynamicInvoice();
  const invoiceId = dynamicInvoiceData.invoice.id;

  const setLineItemCalculationStateMutation = useSetLineItemCalculationState(lineItemId);

  const handleClick = async () => {
    closeMenu?.();
    await runMutation(
      setLineItemCalculationStateMutation,
      {
        disable: !disabled,
      },
      {
        pending: `${disabled ? 'Showing' : 'Hiding'} line item...`,
        success: `${disabled ? 'Shown' : 'Hidden'} line item`,
        error: `Failed to ${disabled ? 'show' : 'hide'} line item`,
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries({
            predicate: (query) =>
              [invoiceId, customerId].some(
                (key) => query.queryKey.includes(key) && query.queryKey.includes('dynamicInvoice'),
              ),
          });
        },
      },
    );
  };

  return (
    <MenuItem onClick={handleClick}>
      <ListItemIcon>
        <DisabledByDefaultIcon
          style={{
            transform: 'scale(0.8)',
          }}
        />
      </ListItemIcon>
      <ListItemText>{`${disabled ? 'Show' : 'Hide'} Item`}</ListItemText>
    </MenuItem>
  );
};
